import { DateTime } from "luxon";
import { ApolloLinkScalar } from "@config/apollo/apollo-link.type";

export const DateScalar: ApolloLinkScalar<DateTime> = {
    parseValue: (value: unknown) => {
        try {
            if (typeof value !== "string") return null;
            const dateModel = DateTime.fromISO(value);
            if (dateModel) return dateModel;
            throw new Error("Couldn't parse a date : " + value);
        } catch (err) {
            console.log("Error parsing date scalar", err);
            return null;
        }
    },
    serialize: (value: unknown) => {
        if (!(value instanceof DateTime)) return null;
        const res = value.toISO();
        if (res) return res;
        const error = new Error("Can't serialize the date object");
        console.error(error);
        throw error;
    },
};
